function customSelect() {

    var x, i, j, l, ll, selElmnt, a, b, c;
    x = document.getElementsByClassName('link-select');
    l = x.length;

    for (i = 0; i < l; i++) {

        selElmnt = x[i].getElementsByTagName('select')[0];
        ll = selElmnt.length;
        a = document.createElement('div');
        a.setAttribute('class', 'select-selected');
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        b = document.createElement('div');
        b.setAttribute('class', 'select-items select-hide');

        for (j = 1; j < ll; j++) {
            c = document.createElement('div');
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.setAttribute('id', 'link-' + selElmnt.options[j].value);
            c.addEventListener('click', function () {
                /* When an item is clicked, update the original select box,
                and the selected item: */
                var y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName('select')[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                for (i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName('same-as-selected');
                        yl = y.length;
                        for (k = 0; k < yl; k++) {
                            y[k].removeAttribute('class');
                        }
                        this.setAttribute('class', 'same-as-selected');
                        if (s.value !== '') {
                            var element = document.querySelector('#' + s.value);
                            var offsetTop = element.offsetTop - 50;
                            scroll({
                                top: offsetTop,
                                behavior: 'smooth',
                            });
                        }
                        break;
                    }
                }
                h.click();
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener('click', function (e) {
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle('select-hide');
            this.classList.toggle('select-arrow-active');
        });
    }

    function closeAllSelect(elmnt) {
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName('select-items');
        y = document.getElementsByClassName('select-selected');
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove('select-arrow-active');
            }
        }
        for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add('select-hide');
            }
        }
    }

    var getElemDistance = function (elem) {
        var location = 0;
        if (elem.offsetParent) {
            do {
                location += elem.offsetTop;
                elem = elem.offsetParent;
            } while (elem);
        }
        return location >= 0 ? location : 0;
    };

    /* If the user clicks anywhere outside the select box,
    then close all select boxes: */
    document.addEventListener('click', closeAllSelect);

    var linkSelect = document.querySelector('.link-select'),
        anchorLinks = document.querySelector('.anchor-link-content');


    if (typeof anchorLinks !== 'undefined' && anchorLinks !== null) {

        var linkSelectTop = getElemDistance(anchorLinks);

        window.addEventListener('resize', function () {

            linkSelectTop = getElemDistance(anchorLinks);

        });

    }

    if (typeof linkSelect !== 'undefined' && linkSelect !== null) {

        window.addEventListener('scroll', function () {

            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > linkSelectTop + 100) {
                linkSelect.classList.add('fix-scroll');
            } else {
                linkSelect.classList.remove('fix-scroll');
            }
        });

    }

    setTimeout(function () {

        const sections = document.querySelectorAll('section.is-anchor');
        const menu_links = document.querySelectorAll('.desktop a');
        const mobile_menu_links = document.querySelectorAll('.select-items div');
        const mobile_link_box = document.querySelector('.select-selected');

        const makeActive = (link) => (typeof (menu_links[link]) !== 'undefined' && menu_links[link] !== null) ? menu_links[link].classList.add('active') : false;
        const makeMobileActive = function (link) {
            if (typeof (mobile_menu_links[link]) !== 'undefined' && mobile_menu_links[link] !== null) {

                [].forEach.call(mobile_menu_links, function (el) {
                    el.classList.remove('same-as-selected');
                });
                mobile_menu_links[link].classList.add('same-as-selected');
                mobile_link_box.innerHTML = mobile_menu_links[link].innerHTML;

            } else {

                mobile_link_box.innerHTML = 'JUMP TO SECTION';

            }
        };
        const removeActive = (link) => menu_links[link].classList.remove('active');
        const removeAllActive = () => [...Array(sections.length).keys()].forEach((link) => removeActive(link));

        const sectionMargin = 200;

        let currentActive = 0;

        // listen for scroll events
        window.addEventListener('scroll', () => {

            const current = sections.length - [...sections].reverse().findIndex((section) => window.scrollY >= section.offsetTop - sectionMargin) - 1

            if (current !== currentActive) {
                removeAllActive();
                currentActive = current;
                makeActive(current);
                makeMobileActive(current);
            }
        });

    }, 1000);

}

export default function init() {
    customSelect();
}


